import React from "react";
import ReactDOM from "react-dom/client";
import "../../app/globals.css";
import "./public-portal.css";
import { PublicApp } from "./PublicApp";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PublicApp />
  </React.StrictMode>,
);
